import { LANGUAGE } from './CommonConstants';

const { ENGLISH, SPANISH } = LANGUAGE;

const OL_R = 'OL-R';
const RET_OL_R = 'RET-OL-R';
const REC_OL_R = 'REC-OL-R';
const WC_SG_R = 'WC-SG-R';

const CONTENT = 'content';
const ORGANIZATION = 'organization';
const SEMANTICS = 'semantics';
const SYNTAX = 'syntax';
const FLUENCY = 'fluency';
const SPELLING = 'spelling';
const WORD_USE = 'word_use';
const GRAMMAR = 'grammar';

const OL_RUBRIC_SECTIONS = [ORGANIZATION, SEMANTICS, SYNTAX, FLUENCY];

const RET_REC_TITLE = {
    [ENGLISH]: 'Oral Language',
    [SPANISH]: 'Lenguaje oral',
};

export const TITLE = {
    [OL_R]: {
        [ENGLISH]: 'Retell and Oral Language',
        [SPANISH]: 'Recontar y Lenguaje oral',
    },
    [RET_OL_R]: RET_REC_TITLE,
    [REC_OL_R]: RET_REC_TITLE,
    [WC_SG_R]: {
        [ENGLISH]: 'Spelling and Grammar',
        [SPANISH]: 'Deletreo y gramática',
    },
};

export const SECTION_MAPPER = {
    [CONTENT]: {
        title: {
            [ENGLISH]: 'Content',
            [SPANISH]: 'Contenido',
        },
        scoresDescription: {
            [ENGLISH]: [
                { score: 1, text: 'Provides one random detail.' },
                { score: 2, text: 'Provides some key details without the main idea.' },
                {
                    score: 3,
                    text: 'Provides the main idea and details not necessarily central to supporting the main idea.',
                },
                {
                    score: 4,
                    text: 'Provides the main idea and most key supporting details.',
                },
            ],
            [SPANISH]: [
                { score: 1, text: 'Provee un solo detalle aleatorio.' },
                {
                    score: 2,
                    text: 'Provee algunos detalles claves sin comentar la idea central.',
                },
                {
                    score: 3,
                    text: 'Provee la idea central, además de detalles, pero no necesariamente asociados a la idea central.',
                },
                {
                    score: 4,
                    text: 'Provee la idea central y la mayoría de los detalles que la apoyan.',
                },
            ],
        },
    },
    [ORGANIZATION]: {
        title: { [ENGLISH]: 'Organization', [SPANISH]: 'Organización' },
        scoresDescription: {
            [ENGLISH]: [
                { score: 1, text: 'Presents ideas with no attention to sequence.' },
                { score: 2, text: 'Presents ideas with some attention to sequence.' },
                {
                    score: 3,
                    text: 'Presents ideas in sequence with some transitional words.',
                },
                { score: 4, text: 'Presents ideas in sequence with transitional words.' },
            ],
            [SPANISH]: [
                {
                    score: 1,
                    text: 'Presenta las ideas sin prestar atención a la secuencia.',
                },
                {
                    score: 2,
                    text: 'Presenta las ideas prestando algo de atención a la secuencia.',
                },
                {
                    score: 3,
                    text: 'Presenta las ideas en secuencia, y utiliza algunas palabras de transición.',
                },
                {
                    score: 4,
                    text: 'Presenta las ideas en secuencia, y utiliza palabras de transición.',
                },
            ],
        },
    },
    [SEMANTICS]: {
        title: { [ENGLISH]: 'Semantics', [SPANISH]: 'Semántica' },
        scoresDescription: {
            [ENGLISH]: [
                { score: 1, text: 'Uses words incorrectly.' },
                {
                    score: 2,
                    text: 'Makes frequent errors on word usage, including words with multiple meanings, shades of meaning, or figurative language, when applicable.',
                },
                {
                    score: 3,
                    text: 'Makes few errors on word usage, including words with multiple meanings, shades of meaning, or figurative language, when applicable.',
                },
                {
                    score: 4,
                    text: 'Makes no errors on word usage, including words with multiple meanings, shades of meaning, or figurative language, when applicable.',
                },
            ],
            [SPANISH]: [
                { score: 1, text: 'Usa las palabras incorrectamente.' },
                {
                    score: 2,
                    text: 'Comete errores frecuentemente en el uso de las palabras, incluyendo las que tienen varios significados, diferentes matices en el significado, o en el uso de lenguaje figurativo, cuando se usa.',
                },
                {
                    score: 3,
                    text: 'Comete pocos errores en el uso de las palabras, incluyendo las que tienen varios significados, diferentes matices en el significado, o en el uso de lenguaje figurativo, cuando se usa.',
                },
                {
                    score: 4,
                    text: 'No comete errores en el uso de las palabras, incluyendo las que tienen varios significados, diferentes matices en el significado, o en el uso de lenguaje figurativo, cuando se usa.',
                },
            ],
        },
    },
    [SYNTAX]: {
        title: { [ENGLISH]: 'Syntax', [SPANISH]: 'Sintaxis' },
        scoresDescription: {
            [ENGLISH]: [
                {
                    score: 1,
                    text: 'Uses mostly short phrases and nouns, with incomplete sentences.',
                },
                {
                    score: 2,
                    text: 'Uses simple sentences with frequent errors in word order (e.g., "a red small bag"), subject-verb agreement, plural form of words, inflectional endings, or verb tenses.',
                },
                {
                    score: 3,
                    text: 'Uses simple or expanded sentences with few errors in word order, subject-verb agreement, plural form of words, inflectional endings, or verb tenses.',
                },
                { score: 4, text: 'Uses simple and expanded sentences with no errors.' },
            ],
            [SPANISH]: [
                {
                    score: 1,
                    text: 'Usa frases y sustantivos cortos, en oraciones incompletas.',
                },
                {
                    score: 2,
                    text: 'Usa oraciones sencillas con errores frecuentes en el orden de las palabras (ej: “una roja pequeña bolsa”), no hay concordancia entre el sujeto y el verbo, ni se aplica correctamente el plural de las palabras, la inflexión correcta de las palabras ni se usan correctamente los tiempos verbales.',
                },
                {
                    score: 3,
                    text: 'Usa oraciones sencillas y complejas con pocos errores en el orden de las palabras, la concordancia entre el sustantivo y el verbo, el plural de las palabras, la inflexión de las palabras y los tiempos verbales.',
                },
                { score: 4, text: 'Usa oraciones sencillas y complejas con pocos errores.' },
            ],
        },
    },
    [FLUENCY]: {
        title: { [ENGLISH]: 'Fluency', [SPANISH]: 'Fluidez' },
        scoresDescription: {
            [ENGLISH]: [
                { score: 1, text: 'Does not speak clearly and hesitates frequently.' },
                {
                    score: 2,
                    text: 'Speaks with limited clarity, pace that is difficult to follow, or little expression.',
                },
                {
                    score: 3,
                    text: 'Speaks mostly clearly at an understandable pace, with minimal hesitations, and with some expression.',
                },
                {
                    score: 4,
                    text: 'Speaks clearly at an understandable pace, and with expression.',
                },
            ],
            [SPANISH]: [
                { score: 1, text: 'No habla claramente y vacila con frecuencia.' },
                {
                    score: 2,
                    text: 'No habla con claridad y el ritmo es difícil de seguir o tiene poca expresión.',
                },
                {
                    score: 3,
                    text: 'Habla con claridad a un ritmo fácil de entender, con poca vacilación y con algo de expresión.',
                },
                {
                    score: 4,
                    text: 'Habla con claridad a un ritmo fácil de entender y con expresión.',
                },
            ],
        },
    },
    [SPELLING]: {
        title: { [ENGLISH]: 'Spelling', [SPANISH]: 'Deletreo' },
        scoresDescription: {
            [ENGLISH]: [
                {
                    score: 0,
                    text: 'No response, or errors interfere with forming a complete word.',
                },
                { score: 1, text: 'Makes some errors.' },
                { score: 2, text: 'Makes no errors.' },
            ],
            [SPANISH]: [
                {
                    score: 0,
                    text: 'No responde, o los errores impiden la formación de la palabra completa.',
                },
                { score: 1, text: 'Comete algunos errores.' },
                { score: 2, text: 'No hay errores.' },
            ],
        },
    },
    [WORD_USE]: {
        title: { [ENGLISH]: 'Word Use', [SPANISH]: 'Uso de Palabras' },
        scoresDescription: {
            [ENGLISH]: [
                {
                    score: 0,
                    text: 'Uses basic words incorrectly (T1 high utility, everyday use).',
                },
                {
                    score: 1,
                    text: 'Uses basic words correctly (T1 high utility, everyday use).',
                },
                {
                    score: 2,
                    text: 'Uses advanced words correctly (T2 cross-curricular or T3 content-area specific).',
                },
            ],
            [SPANISH]: [
                {
                    score: 0,
                    text: 'Usa palabras básicas de manera incorrecta (T1 de alta frecuencia y uso diario).',
                },
                {
                    score: 1,
                    text: 'Usa palabras básicas de manera correcta (T1 de alta frecuencia y uso diario).',
                },
                {
                    score: 2,
                    text: 'Usa palabras complejas de manera correcta (T2 curricular transversal O T3 específico al área de contenido).',
                },
            ],
        },
    },
    [GRAMMAR]: {
        title: { [ENGLISH]: 'Grammar', [SPANISH]: 'Gramática' },
        scoresDescription: {
            [ENGLISH]: [
                {
                    score: 0,
                    text: 'Uses only sentence fragments and incomplete sentences.',
                },
                { score: 1, text: 'Uses only simple or repetitive sentence structures.' },
                {
                    score: 2,
                    text: 'Uses a variety of simple, compound, and complex sentences correctly.',
                },
            ],
            [SPANISH]: [
                {
                    score: 0,
                    text: 'Usa únicamente fragmentos de frases y oraciones incompletas.',
                },
                {
                    score: 1,
                    text: 'Usa únicamente oraciones con estructuras sencillas o repetitivas.',
                },
                {
                    score: 2,
                    text: 'Usa correctamente una variedad de oraciones sencillas, compuestas y complejas.',
                },
            ],
        },
    },
};

export const KEY = { OL_R, RET_OL_R, REC_OL_R, WC_SG_R };

export const SECTION_KEY = {
    CONTENT,
    ORGANIZATION,
    SEMANTICS,
    SYNTAX,
    FLUENCY,
    SPELLING,
    WORD_USE,
    GRAMMAR,
};

export const SECTIONS = {
    [OL_R]: [CONTENT, ...OL_RUBRIC_SECTIONS],
    [RET_OL_R]: OL_RUBRIC_SECTIONS,
    [REC_OL_R]: OL_RUBRIC_SECTIONS,
    [WC_SG_R]: [SPELLING, WORD_USE, GRAMMAR],
};
